/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

// ── パラメーター型定義 ──

export interface AiChatOpenParams {
  experience_slug: string;
}

export interface AiChatCloseParams {
  experience_slug: string;
  message_count: number;
}

export interface AiChatSendMessageParams {
  experience_slug: string;
  message_length: number;
}

export interface AiChatReceiveResponseParams {
  experience_slug: string;
  scope: string;
  response_time_ms: number;
}

export interface AiChatSelectTagParams {
  experience_slug: string;
  tag_label: string;
}

export interface AiChatClickNavigationParams {
  experience_slug: string;
  navigation_type: string;
}

export interface AiChatErrorParams {
  experience_slug: string;
  error_status: number | undefined;
}

export interface AiChatAcceptTermsParams {
  experience_slug: string;
}

// ── 送信関数 ──

/** FABクリックでパネルを開いた時 */
export const sendGAAiChatOpenEvent = (experienceSlug: string) => {
  sendWabunkaGAEvent('ai_chat_open', { experience_slug: experienceSlug });
};

/** パネルを閉じた時 */
export const sendGAAiChatCloseEvent = (experienceSlug: string, messageCount: number) => {
  sendWabunkaGAEvent('ai_chat_close', { experience_slug: experienceSlug, message_count: messageCount });
};

/** メッセージ送信時 */
export const sendGAAiChatSendMessageEvent = (experienceSlug: string, messageLength: number) => {
  sendWabunkaGAEvent('ai_chat_send_message', { experience_slug: experienceSlug, message_length: messageLength });
};

/** AIレスポンス受信時 */
export const sendGAAiChatReceiveResponseEvent = (experienceSlug: string, scope: string, responseTimeMs: number) => {
  sendWabunkaGAEvent('ai_chat_receive_response', { experience_slug: experienceSlug, scope, response_time_ms: responseTimeMs });
};

/** SelectTagクリック時 */
export const sendGAAiChatSelectTagEvent = (experienceSlug: string, tagLabel: string) => {
  sendWabunkaGAEvent('ai_chat_select_tag', { experience_slug: experienceSlug, tag_label: tagLabel });
};

/** ナビゲーションリンククリック時 */
export const sendGAAiChatClickNavigationEvent = (experienceSlug: string, navigationType: string) => {
  sendWabunkaGAEvent('ai_chat_click_navigation', { experience_slug: experienceSlug, navigation_type: navigationType });
};

/** APIエラー発生時 */
export const sendGAAiChatErrorEvent = (experienceSlug: string, errorStatus: number | undefined) => {
  sendWabunkaGAEvent('ai_chat_error', { experience_slug: experienceSlug, error_status: errorStatus });
};

/** 利用規約同意時 */
export const sendGAAiChatAcceptTermsEvent = (experienceSlug: string) => {
  sendWabunkaGAEvent('ai_chat_accept_terms', { experience_slug: experienceSlug });
};
